var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.062 2h-2.78c0 2.501-.069 3.543-1.389 8.963-.419 1.72-1.222 3.416-2.202 5.002h9.857C17.787 11.79 17.062 5.095 17.062 2zM4 23.816c1.592-1.47 4.346-4.202 6.428-7.434h10.408c.213.294.437.572.673.834 3.556 3.946 5.51 6.045 6.043 6.6-.463.672-1.625 2.196-2.57 2.919-.945.722-1.506 1.227-1.668 1.39.093-1.53-.403-4.837-2.849-6.67-3.057-2.294-6.53-2.155-9.935.347-2.14 1.573-2.547 4.886-2.5 6.322-.602-.51-1.946-1.71-2.501-2.432a52.694 52.694 0 0 0-1.53-1.876zm6.045 3.822C10.53 29.097 11.782 30 15.603 30c1.158 0 3.474-.278 4.586-.834 1.325-.663 1.322-1.895 1.32-3.275l-.001-.198c-.001-1.459-1.044-3.335-2.433-4.238-1.39-.903-4.794-1.448-6.948.347-2.155 1.797-2.572 4.379-2.085 5.838zm5.697-.903L14.63 24.58l1.25-2.5 1.043 2.5-1.181 2.155zm0 1.597-.417-.486.417-.486.347.486-.348.486zm-2.362-3.126c1.056 0 1.505 1.02 1.598 1.529-.116-.116-.417-.431-.695-.765-.278-.333-.718.14-.903.417.162.116.486.403.486.625 0 .278-1.112 0-1.39-.277-.278-.278-.416-1.53.904-1.53zm2.848 1.529c.324-.765 1.21-2.14 2.154-1.53.945.612.533 1.46.209 1.807-.347.093-1.083.223-1.25 0-.167-.222.255-.37.486-.416.116-.163.236-.515-.208-.626-.445-.11-1.112.463-1.39.765z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsg);
export default __webpack_public_path__ + "static/media/PSG.78d9ebd7681c80a00c1017bd5df6345c.svg";
export { ForwardRef as ReactComponent };